'use strict';

exports.__esModule = true;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

exports.get = get;
exports.post = post;
exports.put = put;
exports.remove = remove;
exports.setDefaultHeader = setDefaultHeader;

var _utils = require('./utils');

var _eventManager = require('../event-manager/event-manager');

var _eventManager2 = _interopRequireDefault(_eventManager);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_eventManager2.default.registerEvent('onGetQueueTime');

var defaultHeaders = {};

var client = {
  get: get,
  post: post,
  put: put,
  remove: remove,
  setDefaultHeader: setDefaultHeader
};

exports.default = client;

/**
 * Wrapper for network requests, attempts to include authentication token in header
 * and returns a promise for both success and error responses
 */

/**
 * GET request
 * @param {string} req - API endpoint
 * @param {object} [params] - URL params (e.g. ?my=params)
 * @returns {promise} containing network information and entity response
 */

function get(_ref) {
  var url = _ref.url,
      params = _ref.params,
      headers = _ref.headers,
      normaliseResponse = _ref.normaliseResponse,
      timeout = _ref.timeout;

  var request = {
    method: 'get'
  };

  url += params ? (0, _utils.urlEncode)(params) : '';
  return fetchWrapper({ url: url, request: request, headers: headers, normaliseResponse: normaliseResponse, timeout: timeout });
}

/**
 * POST request
 * @param {string} req - API endpoint
 * @param {object} [data] - request body in JSON format (e.g. {my:params})
 * @returns {promise} containing network information and entity response
 */
function post(_ref2) {
  var url = _ref2.url,
      data = _ref2.data,
      formData = _ref2.formData,
      headers = _ref2.headers,
      normaliseResponse = _ref2.normaliseResponse,
      timeout = _ref2.timeout;

  var request = {
    method: 'post',
    body: formData ? data : (0, _utils.body)(data)
  };

  return fetchWrapper({ url: url, request: request, headers: headers, normaliseResponse: normaliseResponse, timeout: timeout });
}

/**
 * PUT request
 * @param {string} req - API endpoint
 * @param {object} [data] - request body in JSON format (e.g. {my:params})
 * @returns {promise} containing network information and entity response
 */
function put(_ref3) {
  var url = _ref3.url,
      data = _ref3.data,
      headers = _ref3.headers,
      normaliseResponse = _ref3.normaliseResponse,
      timeout = _ref3.timeout;

  var request = {
    method: 'put',
    body: (0, _utils.body)(data)
  };

  return fetchWrapper({ url: url, request: request, headers: headers, normaliseResponse: normaliseResponse, timeout: timeout });
}

/**
 * DELETE request
 * @param {string} req - API endpoint
 * @returns {promise} containing network information and entity response
 */
function remove(_ref4) {
  var url = _ref4.url,
      headers = _ref4.headers,
      params = _ref4.params,
      normaliseResponse = _ref4.normaliseResponse,
      timeout = _ref4.timeout;

  var request = {
    method: 'delete'
  };

  url += params ? (0, _utils.urlEncode)(params) : '';
  return fetchWrapper({ url: url, request: request, headers: headers, normaliseResponse: normaliseResponse, timeout: timeout });
}

function setDefaultHeader(key, value) {
  defaultHeaders[key] = value;
}

/**
 * @access private
 */
function fetchWrapper(_ref5) {
  var url = _ref5.url,
      request = _ref5.request,
      headers = _ref5.headers,
      _ref5$normaliseRespon = _ref5.normaliseResponse,
      normaliseResponse = _ref5$normaliseRespon === undefined ? true : _ref5$normaliseRespon,
      _ref5$timeout = _ref5.timeout,
      timeout = _ref5$timeout === undefined ? _config2.default.fetchTimeout : _ref5$timeout;

  var newHeaders = (0, _assign2.default)({}, defaultHeaders, headers);
  var req = (0, _utils.createRequest)({ url: url, request: request, headers: newHeaders });
  var replay = { request: request };

  return (0, _utils.promiseWithTimout)(function () {
    return fetch(url, req).then(function (response) {
      return (0, _utils.httpErrors)({ response: response, replay: replay, url: url, headers: headers });
    }).then(function (response) {
      var queueTime = response && response.headers && response.headers.get('X-QueueTimeSeconds');
      if (queueTime) {
        _eventManager2.default.dispatchEvent('onGetQueueTime', parseInt(queueTime || 0, 10));
      }
      return normaliseResponse ? (0, _utils.handleContentType)(response, req) : response;
    }).catch(_utils.createErrorResponse);
  }, timeout);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/network/client.js
// module id = 95
// module chunks = 0